import React, { Dispatch, SetStateAction } from "react";
import { AllianceDataType } from "../../pages/Alliance/Alliance";
import OrderArrow from "../OrderArrow/OrderArrow";
import ToggleBtn from "../ToggleBtn/ToggleBtn";

interface Props {
  data: AllianceDataType;
  Delete: string | undefined;
  setDelete: Dispatch<SetStateAction<string | undefined>>;
  index: number;
  UpdateBlind: (e: boolean, index: number) => void;
  OrderChange: (e: string, index: number) => void;
  DeleteCard: (e: AllianceDataType) => void;
  NavFixContent: (e: AllianceDataType) => void;
}

/** 제휴 관리 리스트 카드 */
const AllianceCard = ({
  data,
  Delete,
  setDelete,
  index,
  UpdateBlind,
  OrderChange,
  DeleteCard,
  NavFixContent,
}: Props) => {
  const { prtn_nm, prtn_use, prtn_apply_expired_fg, prtn_id, prtn_desc } = data;
  return (
    <div className={`card`}>
      <div className="left-info-wrapper">
        <div className="title">{prtn_nm}</div>
        <div className="content">{prtn_desc}</div>
      </div>
      <div className="right-btn-wrapper">
        <ToggleBtn
          isActive={prtn_apply_expired_fg}
          updateActive={UpdateBlind}
          index={index}
        />
        <OrderArrow OrderChange={OrderChange} index={index} />
        <button
          className="detail-btn"
          onClick={() => {
            NavFixContent(data);
          }}
        >
          상세보기
        </button>
        <button className={`delete-btn`}>
          <img
            src="/assets/common/delete.svg"
            alt="삭제"
            onClick={() => {
              setDelete(prtn_id);
            }}
          />
        </button>
      </div>
      <div className={`delete ${Delete === prtn_id ? "active-delete" : ""}`}>
        <div className="title">항목을 삭제하시겠습니까?</div>
        <div
          className="deleteBox"
          onClick={() => {
            DeleteCard(data);
          }}
        >
          삭제하기
        </div>
      </div>
    </div>
  );
};

export default AllianceCard;
